import Vue from 'vue';
import ElementUI from 'element-ui';
import moment from 'moment';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import '@/styles/main.scss';
import store from '@/store';
import router from '@/router';
import App from '@/App';
import { getCookie, useInternalLogin } from '@/utils/helpers';

Vue.config.productionTip = false;

Vue.use(ElementUI, {
  size: 'small',
});

Vue.filter('datetime', date => moment(date).format('YYYY-MM-DD HH:mm:ss'));

router.beforeEach((to, _from, next) => {
  let unmetCallback = () => {
    window.location = 'http://login.huasi-measure.com';
  }; // 未登录回调

  const isLogin = getCookie('sessionId');
  const isSuper = getCookie('isSuper') === 'true';
  if (useInternalLogin) {
    unmetCallback = () => {
      next({ path: '/login', query: { redirect: to.fullPath } });
    };
  }

  const requireAuth = to.matched.some(record => record.meta.requireAuth);
  const { needSuperAdmin } = to.meta;
  if (requireAuth && !isLogin) {
    unmetCallback();
  } else if (needSuperAdmin && !isSuper) {
    next(false);
  } else {
    next();
  }
});

Object.defineProperty(Vue.prototype, '$bus', {
  get() {
    return this.$root.bus;
  },
});

const bus = new Vue();

new Vue({ // eslint-disable-line no-new
  store,
  router,
  el: '#app',
  data: { bus },
  template: '<App/>',
  components: { App },
});

